import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../config/supabaseClient";
import '../CreateTalkArchive.css'; // Import the CSS file

const Create_adversarie = () => {
  const navigate = useNavigate();

  const [Adversarie, setAdversarie] = useState('');
  const [formError, setFormError] = useState(null);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    if ( !Adversarie ) {
      setFormError('Please fill in all required fields.');
      return;
    }


    try {
      const { data, error } = await supabase
        .from('adversaries') // Ensure this matches your actual table name
        .insert([{
          Adversarie
        }]);

      if (error) {
        console.error('Supabase error:', error);
        setFormError('Error inserting the data. ' + (error.message || 'Unknown error'));
      } else {
        console.log('Insert successful:', data);
        setFormError(null);
        navigate('/home', { replace: true });
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setFormError('Unexpected error occurred. ' + (err.message || 'Unknown error'));
    }
  };

  return (
    <div className="page create">
      <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label htmlFor="Adversarie">Adversarie:</label>
            <input
              type="text"
              id="Adversarie"
              value={Adversarie}
              onChange={(e) => setAdversarie(e.target.value)}
            />
          </div>

        <div className="form-group">
          <button type="submit">Submit</button>
        </div>

        {formError && <p className="error">{formError}</p>}
      </form>
    </div>
  );
};

export default Create_adversarie;
